import {OPEN_IFRAME, CLOSE_IFRAME} from '../actions';

const initialState = {
  url: null,
  title: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_IFRAME:
      const {url, title} = action.payload;
      return {url, title};
    case CLOSE_IFRAME:
      return initialState;
    default:
      return state;
  }
};
